import { IntervalRequestConfig } from '@/lowcode/common/setter/interval-setter/type';
import { IntervalStyle } from '../types';
import { BaseLowCodeProps } from '@/lowcode/common/types';

export enum ColumnChartCategory {
  COLUMN = 'column',
  STACKED_COLUMN = 'stackedColumn',
}

export interface CnColumnStyle extends IntervalStyle {
  height: number;
  category?: ColumnChartCategory;
}

export interface CnColumnChartProps extends BaseLowCodeProps {
  dataFrom?: {
    requestConfig?: IntervalRequestConfig;
  };
  chartStyle: CnColumnStyle;
}
